// key的值必须满足/^[a-zA-Z]+$/
export const PopupPageKey = {
  DETAIL: "detail",
  POINT_HISTORY: "pointHistory",
  PROFILE: "profile",
  INVOICE_HISTORY: "invoiceHistory",
  INVOICE_ADD: "invoiceAdd",
  INVOICE_DETAIL: "invoiceDetail",
  MOBILE_LOGIN: "mobileLogin",
  MOBILE_REGISTER: "mobileRegister",
  FORGET_PASSWORD: "forgetPassword",
  FORGET_PASSWORD_2: "forgetPasswordTwo",
};
